import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import AccountingDocumentService from "../shared/documentInfrastructure/AccountingDocumentService.js";

/**
 * Finds accounts, transactions and ledger entries matching search
 * criteria.
 *
 * @param {Session} session - .
 */
export default class SearchDocumentService extends AccountingDocumentService {
	constructor({ session } = {}) {
		super(...arguments);

		this._session = session;

		this._searchRepository = makeMonitorRepository({
			route: "/Accounting2/Company/#companyId/Search",
			defaultFilters: { companyId: session.getCompanyId() },
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	}

	async fetchInitialData() {
		return {
			...(await super.fetchInitialData(...arguments)),
			searchPeriod: this._session.getCompany().getActiveFiscalYearRange(),
			company: this._session.getCompany(),
		};
	}

	searchLedger({ searchPeriod, searchText, searchArea }) {
		return this._searchRepository.save({
			model: {
				searchArea,
				searchText,
				periodString: searchPeriod.toString(),
			},
			notify: false,
		});
	}
}
